import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/catch';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import { tokenDetail } from '../Models/tokenDetail';
import { UserToken } from '../Models/UserToken'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResultModel } from '../Models/ResultModel';
import { AppSettings } from 'read-appsettings-json';

@Injectable()
export class TokenServices {

  apiURL: string = "";
  userToken = new UserToken();
  appModel: any;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.appModel = AppSettings.Current().ConnectionStrings;
    sessionStorage.setItem('BaseURL', this.appModel.BaseURL);
    //this.apiURL = baseUrl + 'api';        
    //this.apiURL = "http://localhost:60688/" + 'api';
    if (sessionStorage.getItem("BaseURL") != null && sessionStorage.getItem("BaseURL") != "") {
        this.apiURL = sessionStorage.getItem("BaseURL") || '';
        this.apiURL = this.apiURL + 'api';
    }
  }

  getAuthentication(): Observable<tokenDetail> {
    let fullAPIPath = this.apiURL + '/CompanyInformation/Authentication';
    let formData: FormData = new FormData();
    formData.append("ClientID", this.userToken.ClientID);
    formData.append("ClientSecret", this.userToken.ClientSecret);
    return this.http.post<tokenDetail>(fullAPIPath, formData)
      .pipe(catchError(this.handleError));
  }

  private extractData(res: Response) {
    let body = res.json();
    console.log("extractData " + body);
    return body;
  }

  private handleError(error: Response | any) {
    console.error(error.message || error);
    return Observable.throw(error.status)
  }
}
